export const RE_SIZING_PLYWOOD_DONE_REQUEST = "RE_SIZING_PLYWOOD_DONE_REQUEST";
export const RE_SIZING_PLYWOOD_DONE_SUCCESS = "RE_SIZING_PLYWOOD_DONE_SUCCESS";
export const RE_SIZING_PLYWOOD_DONE_FAILED = "RE_SIZING_PLYWOOD_DONE_FAILED";